import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-vctp-up-to-filters',
  templateUrl: './vctp-up-to-filters.component.html',
  styleUrls: ['./vctp-up-to-filters.component.scss']
})
export class VctpUpToFiltersComponent implements OnInit {

  @Input()
  years!: number[];
  @Input()
  secondYear!: boolean;
  @Input()
  yearUsed!: number;

  searchForm = this.formBuilder.group({
    year: [''],
    member: [],
    order: ['alph']
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.orderControl.setValue('alph');
    setTimeout(() => {
      this.yearControl.setValue(this.yearUsed);
    }, 500);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      member: this.memberControl.value,
      order: this.orderControl.value
    };
    this.search.emit(search);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.memberControl.reset();
    this.orderControl.setValue('alph');
    this.search.emit({startYear: this.years[0]});
  }

}
